/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Listing_Error_Size_LargeInputs */

const en_create_listing_error_size_large = /** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is too large (>50MB). Please host larger videos on Vimeo/YouTube and use the Secret Video Link instead.`)
};

const es_create_listing_error_size_large = /** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es demasiado grande (>50MB). Aloja los vídeos grandes en Vimeo/YouTube y usa el Enlace de Vídeo Secreto.`)
};

const fr_create_listing_error_size_large = /** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`est trop volumineux (>50 Mo). Veuillez héberger les vidéos plus grandes sur Vimeo/YouTube et utiliser le lien vidéo secret à la place.`)
};

const de_create_listing_error_size_large = /** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist zu groß (>50MB). Bitte hoste größere Videos auf Vimeo/YouTube und verwende stattdessen den geheimen Videolink.`)
};

const id_create_listing_error_size_large = /** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terlalu besar (>50MB). Harap hosting video yang lebih besar di Vimeo/YouTube dan gunakan Tautan Video Rahasia sebagai gantinya.`)
};

/** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */
const ja_create_listing_error_size_large = en_create_listing_error_size_large;

/** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */
const zh_create_listing_error_size_large = en_create_listing_error_size_large;

/** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */
const ar_create_listing_error_size_large = en_create_listing_error_size_large;

/** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */
const it_create_listing_error_size_large = en_create_listing_error_size_large;

/** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */
const ru_create_listing_error_size_large = en_create_listing_error_size_large;

/** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */
const pt_create_listing_error_size_large = en_create_listing_error_size_large;

/** @type {(inputs: Create_Listing_Error_Size_LargeInputs) => LocalizedString} */
const ko_create_listing_error_size_large = en_create_listing_error_size_large;

/**
* | output |
* | --- |
* | "is too large (>50MB). Please host larger videos on Vimeo/YouTube and use the Secret Video Link instead." |
*
* @param {Create_Listing_Error_Size_LargeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_listing_error_size_large = /** @type {((inputs?: Create_Listing_Error_Size_LargeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Listing_Error_Size_LargeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_listing_error_size_large(inputs)
	if (locale === "es") return es_create_listing_error_size_large(inputs)
	if (locale === "fr") return fr_create_listing_error_size_large(inputs)
	if (locale === "de") return de_create_listing_error_size_large(inputs)
	if (locale === "ja") return ja_create_listing_error_size_large(inputs)
	if (locale === "zh") return zh_create_listing_error_size_large(inputs)
	if (locale === "ar") return ar_create_listing_error_size_large(inputs)
	if (locale === "id") return id_create_listing_error_size_large(inputs)
	if (locale === "it") return it_create_listing_error_size_large(inputs)
	if (locale === "ru") return ru_create_listing_error_size_large(inputs)
	if (locale === "pt") return pt_create_listing_error_size_large(inputs)
	return ko_create_listing_error_size_large(inputs)
});